import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.embed-figma";
const name = "Figma embed";
const icon = "https://cdn-assets.supernova.io/blocks/icons/embed-figma.svg";
const descriptionShort = "Embed a Figma canvas or prototype";
const searchKeywords = ["embed", "figma", "design", "prototype", "canvas"];
const helpText = "Embed a Figma canvas or prototype to your documentation.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/figma/embed-figma-GPNJsT8A";
/**
 * 2. Block properties
 */
const properties = {
    embedUrl: b.embedUrlProperty({
        id: "embed",
        name: "Figma URL",
        options: {
            allowCaption: false,
            allowResize: true,
            defaultHeight: 400,
            isInteractive: false,
            urlValidationRegex: "^(https?://)?(www.)?(embed.)?(figma.com)/.+$",
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.embedUrl],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.embedUrl],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as EmbedFigma };
